var map = {
	"./add-new.svg": 12143,
	"./admin-icon.svg": 35360,
	"./calendar.svg": 6883,
	"./check-with-circle-color.svg": 8091,
	"./check-with-circle-white.svg": 91657,
	"./check.svg": 73079,
	"./chevron-down.svg": 94715,
	"./chevron-left.svg": 14588,
	"./chevron-right.svg": 50563,
	"./chevron-up.svg": 73012,
	"./delete.svg": 94648,
	"./dismiss-close.svg": 80040,
	"./document-pdf.svg": 67835,
	"./edit.svg": 19845,
	"./error-red.svg": 28691,
	"./expert-icon.svg": 14261,
	"./eye-off.svg": 39560,
	"./eye-on.svg": 67714,
	"./health.svg": 82823,
	"./info.svg": 3645,
	"./logo_dc.svg": 95999,
	"./mail-read.svg": 53453,
	"./menu-burger.svg": 70450,
	"./phone.svg": 81363,
	"./search.svg": 75025,
	"./tooltip.svg": 33894,
	"./translate.svg": 58681,
	"./undo.svg": 33983,
	"./user-small.svg": 40202,
	"./warning-1.svg": 5953,
	"./warning-error-red.svg": 9507,
	"./warning-error-white.svg": 75694,
	"images/icons/add-new.svg": 12143,
	"images/icons/admin-icon.svg": 35360,
	"images/icons/calendar.svg": 6883,
	"images/icons/check-with-circle-color.svg": 8091,
	"images/icons/check-with-circle-white.svg": 91657,
	"images/icons/check.svg": 73079,
	"images/icons/chevron-down.svg": 94715,
	"images/icons/chevron-left.svg": 14588,
	"images/icons/chevron-right.svg": 50563,
	"images/icons/chevron-up.svg": 73012,
	"images/icons/delete.svg": 94648,
	"images/icons/dismiss-close.svg": 80040,
	"images/icons/document-pdf.svg": 67835,
	"images/icons/edit.svg": 19845,
	"images/icons/error-red.svg": 28691,
	"images/icons/expert-icon.svg": 14261,
	"images/icons/eye-off.svg": 39560,
	"images/icons/eye-on.svg": 67714,
	"images/icons/health.svg": 82823,
	"images/icons/info.svg": 3645,
	"images/icons/logo_dc.svg": 95999,
	"images/icons/mail-read.svg": 53453,
	"images/icons/menu-burger.svg": 70450,
	"images/icons/phone.svg": 81363,
	"images/icons/search.svg": 75025,
	"images/icons/tooltip.svg": 33894,
	"images/icons/translate.svg": 58681,
	"images/icons/undo.svg": 33983,
	"images/icons/user-small.svg": 40202,
	"images/icons/warning-1.svg": 5953,
	"images/icons/warning-error-red.svg": 9507,
	"images/icons/warning-error-white.svg": 75694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76255;